import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/master/country/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import { useSelector } from "react-redux";
import { getAllCountries } from "../../../../features/admin/common/Slice";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";

const Table = () => {
  const dispatch = useDispatch();

  const Permission = useSelector((state) => state.auth?.admin_info);

  const {
    state,
    name,
    setName,
    country,
    setCountry,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
  } = IndexUse();
  const countries = useSelector((state) => state.common.all_country);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const handleDeleteModal = async (id) => {
    await setDeleteConfirmModal(id);
  };

  const handleDelete = async (id) => {
    await setDeleteConfirmModal(false);
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          {/* <div className="row">
          <div className="col-md-12">
            <Section_title title="Add New State " alltotal="" />
          </div>
        </div> */}

          <div className="row  align-items-end mb-3">
            <div className="col-md-12">
              <Section_title title="State" alltotal="" />
            </div>
            <div className="col-md-4 mb-3 form-group">
              <div className="form-group">
                <label className="form-label">Filter by Country</label>
                <Select
                  name="country_id"
                  value={country}
                  options={countries}
                  placeholder={"Country"}
                  onInputChange={() => {
                    dispatch(getAllCountries());
                  }}
                  onChange={(val) => {
                    setCountry(val);
                    fetch();
                  }}
                />
              </div>
            </div>
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by State Name</label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger"
                onClick={() => {
                  setCountry("");
                  setName("");
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      {Permission.includes(IDS.Permission.State.Add) && (
        <Add
          id={id}
          setId={setId}
          setSuccess={setSuccess}
          setErr={setErr}
          showError={showError}
          setShowError={setShowError}
        />
      )}

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Country </th>
                <th>State </th>
                {Permission.includes(IDS.Permission.State.Edit) && (
                  <th>status </th>
                )}
                {Permission.includes(IDS.Permission.State.Delete) && (
                  <th>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {state?.data?.data?.length > 0 ? (
                state?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(state?.data?.current_page - 1) * state?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.Country?.name}</td>
                    <td>{val?.name}</td>
                    {Permission.includes(IDS.Permission.State.Edit) && (
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${val?.id}`}
                          checked={val?.status}
                          onChange={() => handleStatusChange(val?.id)}
                          label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                        />
                      </td>
                    )}

                    <td>
                      <div className="action_btns">
                        {/* <button type="button" className='editbtn'>
                                                    <Link><img className='icon' src={process.env.PUBLIC_URL + '/assets/images/icons/view.png'} /></Link>
                                                </button> */}
                        {Permission.includes(IDS.Permission.State.Edit) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => setId(val?.id)}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/edit.png"
                                }
                              />
                            </Link>
                          </button>
                        )}
                        {Permission.includes(IDS.Permission.State.Delete) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => handleDeleteModal(val?.id)}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/delete.png"
                                }
                              />
                            </Link>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Delete_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Delete_Confirm_Modal
        handleDelete={handleDelete}
        show={deleteConfirmModal}
        onHide={() => setDeleteConfirmModal(false)}
      />
      <Pagination_Holder
        onPageChange={state?.data?.current_page}
        totalPages={state?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Table;
